import { useTranslation } from '@/hooks/useTranslation';
import { useUserAccess } from '@/hooks/useUserAccess';
import { useDownloadCSV } from '@/hooks/useCompany';
import DownloadIcon from '@simplywallst/ui-core/icons/DownloadXlsSolid';
import { MODAL } from '../constants';
import { useTracking } from 'react-tracking';
import type { ActionClickProps, Action } from '../types';

export const useCsvAction = ({
  canonicalUrl,
  uniqueSymbol,
}: {
  canonicalUrl: string;
  uniqueSymbol: string;
}): Action => {
  const t = useTranslation();
  const userAccess = useUserAccess();
  const downloadCSV = useDownloadCSV(canonicalUrl, uniqueSymbol);
  const { trackEvent } = useTracking();

  const handleClick = ({ setActiveModal }: ActionClickProps) => {
    trackEvent({
      type: 'track',
      action: 'click',
      subject: 'downloadCsv',
    });
    if (userAccess?.data.canGetCompanyReportCsv !== true) {
      setActiveModal(MODAL.PLANS);
      return;
    }
    downloadCSV?.mutate();
  };

  return {
    key: 'csv',
    isDisabled:
      userAccess.status !== 'success' || !canonicalUrl || !uniqueSymbol,
    isHidden: RUNTIME_ENV === 'native',
    smallProps: {
      label: t('page.companyReport.header.actions.downloadToCSV'),
      icon: <DownloadIcon />,
    },
    handleClick,
  };
};
